// Avona frames take only Avona's own wheels, seatposts and cockpits (Faserwerk
// is Avona's component brand), and those parts fit no other frame. The Callis 32
// rolls on 32" (ISO 686) wheels: it takes only 32" tyres, which fit no 700c frame.
export const AVONA_STEPS = ['wheels', 'seatposts', 'bars', 'tyres'];

export const isAvonaFrame = frame => /^Avona\b/i.test(frame && frame.name || '');
export const isAvonaPart = item => /^(Avona|Faserwerk)\b/i.test(item && item.name || '');
export const is32InchFrame = frame => /^Avona Callis 32\b/i.test(frame && frame.name || '');
export const is32InchTyre = item => /\b32"|\b\d{2}-686\b/.test(item && item.name || '');

const partFits = (frame, stepId, item) => stepId === 'tyres'
  ? is32InchTyre(item) === is32InchFrame(frame)
  : isAvonaPart(item) === isAvonaFrame(frame);

export function avonaPartsForFrame(items, frame, stepId) {
  if (!AVONA_STEPS.includes(stepId)) return items;
  return items.filter(item => partFits(frame, stepId, item));
}

export const avonaPartFits = (frame, entry) =>
  !AVONA_STEPS.includes(entry.props.id) || partFits(frame, entry.props.id, entry.item);

// Called only on a user frame selection. Build ids are positional, so a part
// that no longer fits is swapped for the first one that does (options(stepId)
// lists the step in display order), and dropped only when nothing fits.
export function preselectAvonaParts(selection, frame, options) {
  let changed = false;
  const next = selection.flatMap(entry => {
    if (avonaPartFits(frame, entry)) return [entry];
    changed = true;
    const item = (options(entry.props.id) || [])[0];
    return item ? [{ props: entry.props, selected: 0, item: { ...item, type: entry.props.id, step: entry.props }, color: 0 }] : [];
  });
  return changed ? next : selection;
}
